export class QuotingAvailability{
  isDisabled: boolean;
  disabledType: DisbaledType;
}

export enum DisbaledType {
  Month = 'month',
  Day = 'day'
}
